__webpack_require__.p = "https://builder.hk.jewelverse.com/";